"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = require("react");

var _default = (0, _react.createContext)({
  name: null,
  address: null,
  thumbnail: null,
  rating: 0,
  ratingColor: null,
  guestScore: 0,
  amenities: [{
    name: null,
    icon: null
  }],
  checkInDate: null,
  checkOutDate: null,
  checkInTime: null,
  checkOutTime: null,
  nights: 0,
  rooms: 0,
  adults: 0,
  children: 0
});

exports["default"] = _default;